export default {
  name: "BrowserWalletImg"
};